import _ from '@/utils/lodash-optimized'

import http from './http'

const TIMEOUT = '500'

const url = params => {
  const { path } = params
  return `/admin/igao/${path}`
}

const get = path => http.getRequest(url(path))

const put = _.debounce(
  (params, resolve, reject) =>
    http
      .putRequest(url(params), _.pick(params, [ 'data' ]))
      .then(resolve)
      .catch(reject),
  TIMEOUT
)

const set = params =>
  new Promise((resolve, reject) => put(params, resolve, reject))

const publish = params =>
  http.postRequest(url(params), _.pick(params, [ 'data' ]))

const getMetaData = () => http.getRequest(url({ path: 'metadata' }))

const setDefault = params =>
  http.putRequest(`/admin/igao/setDefault/${params.path}`)

const revert = params => http.deleteRequest(url(params))

export default {
  set,
  get,
  publish,
  getMetaData,
  setDefault,
  revert
}
